define('modules/form_editor/views/preview_dropdown',['require','exports','module','./preview_group_base','./preview_dropdown_item','../../editor/models/editorstate','env','ldsh!../templates/dropdown'],function(require, exports, module){
  "use strict";
  var PreviewGroupBase = require("./preview_group_base"),
      PreviewDropDownItem = require("./preview_dropdown_item"),
      EditorState = require("../../editor/models/editorstate"),
      config = require("env");

  module.exports = PreviewGroupBase.extend({
    itemView: PreviewDropDownItem,
    itemContainer: "select",

    template: require("ldsh!../templates/dropdown"),

    helpers: function () {
      var templateParams = {
        isAMP: EditorState.getAMPState()
      };

      if (templateParams.isAMP) {
        templateParams.url = this.buildDynamicURL();
      }

      return templateParams;
    },

    buildDynamicURL: function () {
      var url = this.model.get('url');

      if (url) {
        return config.apiHost + '/amp-dynamic-field?url=' + encodeURIComponent(url);
      }

      return url;
    }
  });
});

